import { render, staticRenderFns } from "./ReferentielPro.vue?vue&type=template&id=0ffa5b73&"
import script from "./ReferentielPro.vue?vue&type=script&lang=js&"
export * from "./ReferentielPro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports